import React, { Component } from 'react';
import { LocalizationContext } from 'localize-react';

import { customTranslate } from '../../utils';
import FooterContent from './footer-content';

export default class Footer extends Component {

    footerRows = new FooterContent().footerRows;

    render() {
        return (
            <div className="footer">
                {this.footerRows.map((row, index) => <div className="footer-content" key={index}> {customTranslate(row, this.context)} </div>)}
            </div>
        )
    }
}

Footer.contextType = LocalizationContext;